import { useEffect } from 'react';
import { matchPath } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from '@kiper/theme';
import { renderRoutes } from 'react-router-config';
import propTypes from 'prop-types';

import GlobalStyle from '../../globalStyle';
import Header from '../Header';
import * as S from './styles';

const isDevelopment = process.env.NODE_ENV === 'development';

const firebase = !isDevelopment ? require('../../services/firebase') : null;

const hideHeaderRoutes = [
  '/guest',
  '/activate',
  '/package-delivery',
  '/package-delivery-correios',
  '/deposit-package',
  '/convite-personalizado',
  '/convite-personalizado/cadastro-facial',
  '/calendar',
];

const Root = ({ route, location }) => {
  const hideHeader = hideHeaderRoutes.some(hideHeaderRoute =>
    matchPath(location.pathname, {
      path: hideHeaderRoute,
      exact: false,
      strict: false,
    }),
  );

  useEffect(() => {
    if (firebase) {
      const currentRoute = route.routes.find(routeObj =>
        matchPath(location.pathname, routeObj),
      );
      const firebaseInstance = firebase.getFireInstance();
      firebase.logEvent(firebaseInstance, 'page_view', {
        page_title: currentRoute && currentRoute.name,
        page_location: location.pathname,
      });
    }
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {hideHeader ? (
        <main>{renderRoutes(route.routes)}</main>
      ) : (
        <S.RootWrapper>
          <Header />
          <main>{renderRoutes(route.routes)}</main>
        </S.RootWrapper>
      )}
    </ThemeProvider>
  );
};
export default Root;

Root.propTypes = {
  route: propTypes.object.isRequired,
  location: propTypes.object.isRequired,
};
